import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdge } from "@fortawesome/free-brands-svg-icons";

function AppSplit({appStats}) {
  const platforms = [
    {
      name: "iOS",
      count: appStats?.appCounts?.ios ?? 0,
      logo: "/applelogo.png",
      alt: "Apple Logo",
      icon: null,
    },
    {
      name: "Android",
      count: appStats?.appCounts?.android ?? 0,
      logo: "/androidlogo.png",
      alt: "Android Logo",
      icon: null,
    },
    {
      name: "Chrome",
      count: appStats?.appCounts?.chrome ?? 0,
      logo: "/chromelogo.svg.webp",
      alt: "Chrome Logo",
      icon: null,
    },
    {
      name: "Edge",
      count: appStats?.appCounts?.edge ?? 0,
      logo: "/edgelogo.png",
      alt: "Edge Logo",
      icon: null,
    },
  ];

  return (
    <table className="w-full">
      <tbody>
        {platforms.map((platform) => (
          <tr key={platform.name} className="border-b border-gray-200 last:border-b-0">
            <td className="py-3 flex items-center">
              {platform.logo ? (
                <img
                  className="h-8 w-8 object-contain mr-3"
                  src={platform.logo}
                  alt={platform.alt}
                />
              ) : (
                <FontAwesomeIcon
                  icon={platform.icon}
                  className="h-8 w-8 mr-3"
                  style={{ color: '#0078D4' }}
                />
              )}
              <span className="text-gray-700 font-medium">{platform.name}</span>
            </td>
            <td className="py-3 text-right">
              <span className="text-gray-900 font-semibold text-lg">{platform.count}</span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default AppSplit;
